<script>
    import { createEventDispatcher } from 'svelte'
    import Dropdown from '../../shared/Dropdown.svelte'
    import Modal    from '../../shared/SemanticModal.svelte'

	const dispatch = createEventDispatcher()

    export let groups = []
    export let group  = null

    $: options  = [...groups, { text: 'Novo Grupo' }]
    $: selected = group && options.find(op => op.text === group)

    let active = false
    let name = null

    function onChange(it) {
        if(!it.id) {
            name   = null
            active = true
        } else {
            active = false
            dispatch('group', { add: true, group: it.text })
        }
    }
    
    function cancel() {
        name   = null
        active = false
    }

    function add() {
        dispatch('group', { add: true, group: name })
        cancel()
    }

</script>

<div style="display: flex; justify-content: flex-start">
    <Dropdown text="Grupo" noOption={true} {options} {onChange} {selected} />
</div>

<Modal {active}>
    <div class="ui tiny modal visible active">
        <div class="header">
            Novo Grupo
        </div>
        <div class="content">
            <div class="ui left aligned basic segment">
                <div class="ui right icon big input">
                    <input bind:value={ name }>
                </div>            
            </div>
        </div>
        <div class="actions">
            <button class="ui black button" on:click={cancel}>
                Cancelar
            </button>
            <button class="ui blue button" on:click={add}>
                Adicionar
            </button>
        </div>
    </div>
</Modal>


